import "./RadioComp.css";
import { defineComponent as m, computed as i, openBlock as C, createElementBlock as b, normalizeClass as a, createElementVNode as l, renderSlot as v, toDisplayString as f } from "vue";
import { i as V } from "./isEqual.398c54af.js";
import { _ as h } from "./_plugin-vue_export-helper.dad06003.js";
const k = ["t-sel", "id", "disabled", "checked"], y = /* @__PURE__ */ m({
  __name: "RadioComp",
  props: {
    id: {},
    modelValue: {},
    option: {}
  },
  emits: ["update:modelValue"],
  setup(d, { emit: s }) {
    const e = d, n = s, t = i(() => V(e.option, e.modelValue)), p = i(() => ({
      radioComp__label: !0,
      "radioComp__label--disabled": e.option.disabled
    })), r = i(() => ({
      radioComp__inputContainer: !0,
      "radioComp__inputContainer--selected": !!e.modelValue,
      "radioComp__inputContainer--disabled": e.option.disabled
    })), _ = i(() => ({
      radioComp__input: !0,
      "radioComp__input--disabled": e.option.disabled
    })), u = i(() => ({
      radioComp__labelText: !0,
      "radioComp__labelText--disabled": e.option.disabled
    })), c = () => n("update:modelValue", e.option);
    return (o, x) => (C(), b("label", {
      class: a(p.value)
    }, [
      l("div", {
        class: a(r.value)
      }, [
        l("div", {
          class: a({
            radioComp__circle: !0,
            "radioComp__circle--selected": t.value,
            "radioComp__circle--disabled": o.option.disabled
          })
        }, null, 2),
        l("input", {
          class: a(_.value),
          "t-sel": e.id,
          id: e.id,
          disabled: o.option.disabled,
          type: "radio",
          checked: t.value,
          onInput: c
        }, null, 42, k)
      ], 2),
      v(o.$slots, "label", { option: o.option }, () => [
        l("span", {
          class: a(u.value)
        }, f(o.option.text), 3)
      ], !0)
    ], 2));
  }
});
const T = /* @__PURE__ */ h(y, [["__scopeId", "data-v-200e4794"]]);
export {
  T as RadioComp
};
//# sourceMappingURL=RadioComp.js.map
